export default function removeHtmlTags(htmlText: string = ''): string {
  if (htmlText?.length > 0) {
    const tagPattern = /<[^>]*>/g;
    const plainText = htmlText?.replace(tagPattern, '')?.trim();

    return plainText;
  }
  return '';
}
